import React, { useEffect, useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { axios } from "../../../../../Global";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setAppError, setBreadCrumb } from "../../../../../store/userSlice";
import { BiDotsVerticalRounded, BiEdit, BiHide, BiShow } from "react-icons/bi";
import { MdDeleteOutline } from "react-icons/md";
import { CiEdit } from "react-icons/ci";
import ContractCostSheetEdit from "../ContractCostSheetEdit";
import ContractFileUpload from "../ContractFileUpload";
import ContractAdvancedSecurityTable from "../ContractAdvancedSecurity";
import ProceedToProject from "../ProceedToProjectPopup";
import useSearchPagination from "../../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { checkAccessFn } from "../../../../../utils/checkAccess";
import ContractViewFirstTable from "./ContractViewFirstTable";
import ContractCompanyDetailsTable from "./ContractCompanyDetailsTable";

const ContractClientDetailsTable = ({ contractDetails }) => {
  let clientDetails = contractDetails?.client;

  console.log(clientDetails, "client detials")
  
  let clientData = [
          {
            title: "Client ID",
            value: clientDetails?.client_id,
          },
          {
            title: "Company Name",
            value: clientDetails?.name,
          },
          {
            title: "Company Logo",
            value: clientDetails?.logo,
            image: true,
          },
          {
            title: "Company Email",
            value: clientDetails?.email,
          },
          {
            title: "Company Landline Number",
            value: clientDetails?.mobile,
          },
          {
            title: "National Address",
            value: clientDetails?.address,
    },
          {
            title: "PO BOX",
            value: clientDetails?.po_box,
    }, {
            title: "PIN CODE",
            value: clientDetails?.pincode,
    }, {
            title: "NATIONAL IDENTITY NO",
            value: clientDetails?.national_identification_number,
    },
          {
            title: "Head Office Location",
            value: clientDetails?.head_office_location,
    },
          {
            title: "CR NUMBER",
            value: clientDetails?.company_registration,
    },
          {
            title: "LABOR OFFICE FILE NUMBER (MOL)",
            value: clientDetails?.labor_license_number,
    },
           {
            title: "CLIENT SPECIFIC INSTRUCTION",
            value: clientDetails?.client_specific,
          },
          {
            title: "Company Sponsor ID (700 series)",
            value: clientDetails?.sponsor_id,
    },
           {
            title: "VAT NUMBER",
            value: clientDetails?.vat_number,
    },
    {
            title: "Authorized Person Name",
            value: clientDetails?.authorized_person_name,
          },
           {
            title: "Authorized Person Contact",
            value: clientDetails?.authorized_person_contact,
          },
          {
            title: "Authorized Person Designation",
            value: clientDetails?.authorized_person_designation,
          },
          {
            title: "Authorized Person Email",
            value: clientDetails?.authorized_person_email,
    },
           {
            title: "Authorized Project Representative Name",
            value: clientDetails?.authorized_project_representative_name,
          },
           {
            title: "Authorized Project Representative Contact",
            value: clientDetails?.authorized_project_representative_contact,
          },
          {
            title: "Authorized Project Representative Designation",
            value: clientDetails?.authorized_project_representative_designation,
          },
          {
            title: "Authorized Project Representative Email",
            value: clientDetails?.authorized_project_representative_email,
          },
         
          // {
          //   title: "Sponsor Name",
          //   value: clientDetails?.sponsor_name,
          // },
          {
            title: "Authorized Accounts Representative Contact",
            value: clientDetails?.authorized_accounts_representative_contact,
          },
          {
            title: "Authorized Accounts Representative Designation",
            value:
              clientDetails?.authorized_accounts_representative_designation,
          },
          {
            title: "Authorized Accounts Representative Email",
            value: clientDetails?.authorized_accounts_representative_email,
          },
          {
            title: "Authorized Accounts Representative Name",
            value: clientDetails?.authorized_accounts_representative_name,
          },
         
         
          {
            title: "Bank Account Number",
            value: clientDetails?.bank_account_number,
          },
          {
            title: "Bank Branch",
            value: clientDetails?.bank_branch,
          },
          {
            title: "Bank Iban",
            value: clientDetails?.bank_iban,
          },
          {
            title: "Bank Name",
            value: clientDetails?.bank_name,
          },
          {
            title: "Bank Type",
            value: clientDetails?.bank_type,
          },
          {
            title: "Beneficiary Bank",
            value: clientDetails?.beneficiary_bank,
          },
        ]

  return (
    <>
      <div
        className={`grid 2xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-x-5 gap-y-10 bg-slate-50 shadow-md rounded-lg px-5 transition-all overflow-auto py-5 h-auto my-4`}
      >
        {clientData?.map((elem, i) => (
          <div key={i} className="p-3 flex flex-col gap-2">
            <h2 className="font-semibold">{elem.title}</h2>
            {elem.image ? (
              <img src={`${elem.value}`} alt={elem.title} width={"100px"} />
            ) : (
              <p>{elem.value || "--"}</p>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default ContractClientDetailsTable;
